import {
  getMPUrl,
  hasUserSubscribe,
  getSignature,
} from '@/api/mediaplatformserv'

export default {
  state: {
    state_MediaPlatform_GetMPUrlResult: null,
    state_MediaPlatform_HasUserSubscribeResult: null,
    state_MediaPlatform_GetSignatureResult: null,
  },
  mutations: {
    SET_MEDIAPLATFORM_GETMPURL_RESULT: (state, rst) => {
      state.state_MediaPlatform_GetMPUrlResult = rst;
    },
    SET_MEDIAPLATFORM_HASUSERSUBSCRIBE_RESULT: (state, rst) => {
      state.state_MediaPlatform_HasUserSubscribeResult = rst;
    },
    SET_MEDIAPLATFORM_GETSIGNATURE_RESULT: (state, rst) => {
      state.state_MediaPlatform_GetSignatureResult = rst;
    },
  },
  actions: {
    MediaPlatformServ_GetMPUrl({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMPUrl(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEDIAPLATFORM_GETMPURL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEDIAPLATFORM_GETMPURL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MediaPlatformServ_HasUserSubscribe({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        hasUserSubscribe(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEDIAPLATFORM_HASUSERSUBSCRIBE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEDIAPLATFORM_HASUSERSUBSCRIBE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    MediaPlatformServ_GetSignature({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getSignature(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_MEDIAPLATFORM_GETSIGNATURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_MEDIAPLATFORM_GETSIGNATURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_MediaPlatform_GetMPUrlResult: state => {
      return state.state_MediaPlatform_GetMPUrlResult;
    },
    get_MediaPlatform_HasUserSubscribeResult: state => {
      return state.state_MediaPlatform_HasUserSubscribeResult;
    },
    get_MediaPlatform_GetSignatureResult: state => {
      return state.state_MediaPlatform_GetSignatureResult;
    },
  }
}